import React from 'react';
import { Link } from 'react-router-dom';
import { HITLAB_HOME_RESUME_PAYMENT_PATH } from './hitLabProfileReady';

export default function HitLabProfileReadyHomeCard({ onResume }) {
  return (
    <section className="homeHitLabResumeCard" aria-label="HitLab resume card">
      <span>JG HITLAB</span>
      <div className="homeHitLabResumeBody">
        <h2>Your JG Artist Profile is ready.</h2>
        <p>
          Joe Galaxy Radio is live in the capsule above. Hear what is in
          rotation, then put one original record through HitLab when you are
          ready.
        </p>
        <p>
          Every paid intake is personally heard and receives a curator response.
        </p>
        <p className="homeHitLabResumeRate">
          Founding processing: $9.99
          <br />
          Standard processing after the founding window: $19.99
        </p>
        <p className="homeHitLabResumeGuidance">
          Tap the Joe Galaxy Radio Live Capsule to hear what is in rotation.
        </p>
      </div>
      <Link
        className="homeHitLabResumeCta"
        to={HITLAB_HOME_RESUME_PAYMENT_PATH}
        onClick={onResume}
      >
        Put One Record Through HitLab - $9.99
      </Link>
    </section>
  );
}
